function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".virtual_devices_svg__cls-1{fill:#f5f8fc}"));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "virtual_devices_svg__Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "virtual_devices_svg__Capa_6",
  "data-name": "Capa 6"
}, React.createElement("path", {
  className: "virtual_devices_svg__cls-1",
  d: "M26 18.67v-8.42-6.78a2.35 2.35 0 00-.66-1.72A4.29 4.29 0 0023.63.64a14.79 14.79 0 00-7.39-.31A5.91 5.91 0 0013.8 1.6a2.27 2.27 0 00-.8 1.73v17.9a2.75 2.75 0 001.36 2.5 7.69 7.69 0 003.1 1.13 13.44 13.44 0 003.84 0l.53-.09a6.69 6.69 0 003.25-1.36l.1-.09a2.32 2.32 0 00.82-1.86v-1.93zm-2.4 1.4a6.84 6.84 0 01-2.52.71 11.1 11.1 0 01-4.67-.32 7 7 0 01-1.41-.71.69.69 0 01-.31-.63v-7.86V8a11.12 11.12 0 009.67 0V18.81a1.29 1.29 0 01-.77 1.26zM22.13 7.13A11.66 11.66 0 0116.4 7a6.08 6.08 0 01-1.33-.63.88.88 0 01-.42-.92 11.25 11.25 0 009.69 0 1 1 0 01-.42.92 4.23 4.23 0 01-1.79.76zm1.92-3.39a3.78 3.78 0 01-1.83.85 11.67 11.67 0 01-5.89-.13 4.42 4.42 0 01-1.21-.58.92.92 0 01-.47-.66 1 1 0 01.47-.72 4.92 4.92 0 012-.77 10.56 10.56 0 011.11-.17c.3 0 .61 0 .88-.06h.32a10.07 10.07 0 013.74.63 3.47 3.47 0 01.89.55.72.72 0 01.29.51.77.77 0 01-.3.56zm.29 17.69a.93.93 0 01-.32.84 3.49 3.49 0 01-1.41.71 11.62 11.62 0 01-6.34 0 4.46 4.46 0 01-.93-.4 1.06 1.06 0 01-.69-1.11 11.26 11.26 0 009.69-.03z"
}), React.createElement("rect", {
  className: "virtual_devices_svg__cls-1",
  x: 16.12,
  y: 2.52,
  width: 2.4,
  height: 1.24,
  rx: 0.62,
  ry: 0.62
}), React.createElement("rect", {
  className: "virtual_devices_svg__cls-1",
  x: 20.47,
  y: 2.52,
  width: 2.4,
  height: 1.24,
  rx: 0.62,
  ry: 0.62
}), React.createElement("path", {
  className: "virtual_devices_svg__cls-1",
  d: "M11.57 18.15c0-.43-.06-.86-.09-1.29v-.8-.48l-.23-2.65c-.11-1.19-.22-2.38-.32-3.57a.43.43 0 010-.05 1.71 1.71 0 00-.9-1.32 3.92 3.92 0 00-.58-.24 6.75 6.75 0 00-1.9-.3h-.76a10 10 0 00-3.4.52 5.35 5.35 0 00-1.81 1A1.85 1.85 0 001 10.06c-.09.67-.18 1.35-.26 2l-.17 1.3c-.13 1-.26 2.11-.37 3.17a19.62 19.62 0 00-.2 2.6 4.72 4.72 0 00.12 1.06 1.29 1.29 0 00.09.33q.05.18.12.35a4.74 4.74 0 00.32.65 3.22 3.22 0 001.19 1.23 6.33 6.33 0 001.65.61 10.67 10.67 0 004.77 0 4.69 4.69 0 001.66-.67 3.62 3.62 0 001.19-1.52 6.2 6.2 0 00.38-1.33 7 7 0 00.08-1.69zM2.68 9.93a4.16 4.16 0 011.22-.65 8.3 8.3 0 012.89-.43h.56a5.58 5.58 0 011.49.23 1.63 1.63 0 01.29.12l.14.07-.13.1a6.89 6.89 0 01-3.59 1.15 7.31 7.31 0 01-.78 0 3.61 3.61 0 01-2.08-.46L2.58 10zM1.71 16L2 13.49l.15-1.23v-.71l.13.06a6.75 6.75 0 003.3.39 9.67 9.67 0 003.65-1l.14-.06.08.89c0 .42.07.82.1 1.24L9.91 16a8.63 8.63 0 01-4.06.86 8.47 8.47 0 01-4.14-.8zm8 4.6a2.32 2.32 0 01-.87 1.05 3.72 3.72 0 01-1.45.35 10.46 10.46 0 01-1.48.1 10.78 10.78 0 01-1.49-.1c-.24 0-.48-.07-.71-.13a3.66 3.66 0 01-1-.36 2.14 2.14 0 01-.77-.85 3.36 3.36 0 01-.42-1.44v-.18c0-.4 0-.85.06-1.43v-.11a9.32 9.32 0 004.31.79 8.72 8.72 0 004.11-.78v.12a2.29 2.29 0 010 .25v.35a5.12 5.12 0 01-.26 2.35z"
})));

var SvgVirtualDevices = function SvgVirtualDevices(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 26 25"
  }, props), _ref, _ref2);
};

export default SvgVirtualDevices;